import React from "react";
import { ChartProps } from "./Chart";
import { Box, Divider, Stack } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import BasicDetails from "../component/GeneDetails/BasicInformation";

const GeneDetails = (props: ChartProps) => {
  const geneDetails =
    props.records.length > 0 ? props.records[0]["_fields"][0].properties : null;

  const [value, setValue] = React.useState(0);
  const [extraRecords, setExtraRecords] = React.useState([]);
  const [sequenceData, setSequenceData] = React.useState();
  const [geneFamilyData, setGeneFamilyData] = React.useState();
  const [functionaldata, setFunctionalData] = React.useState();
  const [expressionData, setExpressionData] = React.useState();

  const getGeneDetails = () => {
    // TODO: Need to modify the query to get the sequence data
    props?.queryCallback &&
      props.queryCallback(
        "MATCH (n:Gene) WHERE n.gene_id = 'AT1G01010' RETURN n",
        {},
        setSequenceData
      );
  };

  const getSequenceData = () => {
    // TODO: Need to modify the query to get the sequence data
    props?.queryCallback &&
      props.queryCallback(
        "MATCH (n:Gene) WHERE n.gene_id = 'AT1G01010' RETURN n",
        {},
        setSequenceData
      );
  };

  const getGeneFamilyData = () => {
    // TODO: Need to modify the query to get the sequence data
    props?.queryCallback &&
      props.queryCallback(
        "MATCH (n:Gene) WHERE n.gene_id = 'AT1G01010' RETURN n",
        {},
        setGeneFamilyData
      );
  };

  const getFunctionalData = () => {
    // TODO: Need to modify the query to get the sequence data
    props?.queryCallback &&
      props.queryCallback(
        "MATCH (n:Gene) WHERE n.gene_id = 'AT1G01010' RETURN n",
        {},
        setFunctionalData
      );
  };

  const getExpressionData = () => {
    // TODO: Need to modify the query to get the sequence data
    props?.queryCallback &&
      props.queryCallback(
        "MATCH (n:Gene) WHERE n.gene_id = 'AT1G01010' RETURN n",
        {},
        setExpressionData
      );
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        getGeneDetails();
        break;
      case 1:
        getSequenceData();
        break;
      case 2:
        getGeneFamilyData();
        break;
      case 3:
        getFunctionalData();
        break;
      case 4:
        getExpressionData();
        break;
    }
    setValue(newValue);
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Basic Information" {...a11yProps(0)} />
          <Tab label="Sequence" {...a11yProps(1)} />
          <Tab label="Gene Family" {...a11yProps(2)} />
          <Tab label="Functional" {...a11yProps(3)} />
          <Tab label="Expression" {...a11yProps(4)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <BasicDetails geneDetails={geneDetails} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        Sequence
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        Gene Family
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        Functional
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        Expression
      </CustomTabPanel>
    </Box>
  );
};

export default GeneDetails;
